module.exports = __webpack_public_path__ + "static/media/16UNODC39.35795101.jpg";